import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';

function passwordsMatch(control: AbstractControl): ValidationErrors | null {
  const newPassword = control.get('newPassword')?.value;
  const confirmPassword = control.get('confirmPassword')?.value;
  return newPassword === confirmPassword ? null : { mismatch: true };
}

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['../configuration-form.css'],
})
export class ChangePasswordDialogComponent {
  form: FormGroup;
  submitting = false;
  error = '';

  constructor(
    fb: FormBuilder,
    private auth: AuthService,
    private dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
  ) {
    this.form = fb.group(
      {
        currentPassword: ['', Validators.required],
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: passwordsMatch },
    );
  }

  submit(): void {
    if (this.form.invalid || this.submitting) return;

    this.submitting = true;
    this.error = '';
    const { currentPassword, newPassword } = this.form.value;
    this.auth.changePassword(currentPassword, newPassword).subscribe({
      next: () => this.dialogRef.close({ changed: true }),
      error: err => {
        this.submitting = false;
        this.error = err.error?.message
          || `Couldn't change password (error ${err.status || 'network'}).`;
      },
    });
  }

  cancel(): void {
    if (this.form.dirty && !confirm('Discard password change?')) return;
    this.dialogRef.close();
  }
}
